const FeaturesListDetail = ({
  title = 'Plan Features',
  planFeatures = [],
}) => {
  return (
    <div className='FeaturesListAdd-box-container detail-features-container'>
      <div className='FeaturesListAdd-heading'>
        <span className='common-text ftw-5 fts-18 black'>{title}</span>
      </div>
      <div className='features-list scrollable-container'>
        {planFeatures.map((option, index) => (
          <div key={option.id || index} className='new-features-items'>
            <span className='common-text ftw-4 fts-15 dk-gray'>{option.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesListDetail;